import { FC } from "react";
import { SxProps, Grid } from "@mui/material";
import MovieCard, { MovieCardProps } from "../../Cards/MovieCard/movie-card";

import "swiper/css";
import Slider, { Slide } from "../../Slider";
import MovieCardSkeleton from "../../Cards/MovieCard/MovieCardSkeleton";
import MovieCardBundles from "../../Cards/MovieCard/movie-card-bundles";

export type MovieSliderProps = {
  sx?: SxProps;
  list: Omit<MovieCardProps, "index">[];
  background?: "default" | "paper";
  paginate?: boolean;
  loading?: boolean;
  nbLoadingItems?: number;
  bundleMaker?: boolean;
};

const MovieSlider: FC<MovieSliderProps> = (props) => {
  const {
    list,
    paginate = true,
    background = "default",
    sx = {},
    loading = false,
    nbLoadingItems = 6,
    bundleMaker = false,
  } = props;
  const loadingList = Array(nbLoadingItems).fill("loading");

  if (loading) {
    return (
      <Grid container spacing={2} sx={{ pb: 6 }}>
        {loadingList.map((a, i) => (
          <Grid item md={12 / nbLoadingItems} key={i}>
            <MovieCardSkeleton />
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <Slider
      sx={{
        ...sx,
        ".swiper-slide": {
          flexShrink: 1,
          height: "auto",
        },
        ".swiper-wrapper": {
          mb: 1,
          pt: 1,
        },
        ".MuiMovieCard": {
          width: "200px",
        },
      }}
      paginate={bundleMaker ? false : paginate}
      background={background}
      slidesPerGroup={3}
      spaceBetween={bundleMaker ? 8 : 16}
    >
      {list.map((movie, index) => (
        <Slide key={movie.id}>
          {bundleMaker ? (
            <MovieCardBundles shareBtn={true} orderBtn={true} {...movie} selectMode={false} />
          ) : (
            <MovieCard shareBtn={true} orderBtn={true} {...movie} selectMode={false} />
          )}
        </Slide>
      ))}
    </Slider>
  );
};

export default MovieSlider;
